<template>
  <div class="container">

    <div class="clearfix" v-if="!complete">
      <div class="c1 incomplete-profile">
        Welcome to PFX!<br/>
        You need to complete your profile before proceeding.
      </div>
    </div>

    <ProfilePageMenu />
    <!--<h2>My Profile</h2>-->

    <div>
      <form ref="profileForm">

        <div class="clearfix">
          <div class="c1">

            <h3>Personal Information</h3>
            <div class="clearfix">
              <fieldset class="half">
                <label for="firstName">First Name *</label>
                <input v-model="userData.firstName" id="firstName" type="text" required />
              </fieldset>
              <fieldset class="half">
                <label for="lastName">Last Name *</label>
                <input v-model="userData.lastName" id="lastName" type="text" required />
              </fieldset>
              <fieldset class="half">
                <label for="alias">Username *</label>
                <input v-model="userData.alias" id="alias" type="text" required />
                <small>Instead of your real name, username is displayed during bidding to the other participants.</small>
              </fieldset>
            </div>

            <h3>Contact Information</h3>
            <div class="clearfix">
              <fieldset class="half">
                <label for="email2">Email Address *</label>
                <input v-model="userData.email" id="email2" type="email" required />
                <small>You'll receive notifications via email during the auction process, so make sure the address is correct.</small>
              </fieldset>
              <fieldset class="half">
                <label for="phone">Cell Phone Number *</label>
                <input v-model="userData.phone" id="phone" type="tel" title="Phone number format must be (123)123-1234567" pattern="[(][0-9]{3}[)][0-9]{3}[-][0-9]{4,7}" required />
              </fieldset>
              <fieldset class="half">
                <label for="officePhone">Office Phone Number</label>
                <input v-model="userData.officePhone" id="officePhone" type="tel" title="Phone number format must be (123)123-1234567" pattern="[(][0-9]{3}[)][0-9]{3}[-][0-9]{4,7}" />
              </fieldset>
              <!--
              <fieldset class="half">
                <label for="fax">Fax Phone Number</label>
                <input v-model="userData.fax" id="fax" type="tel" title="Phone number format must be (123)123-1234567" pattern="[(][0-9]{3}[)][0-9]{3}[-][0-9]{4,7}" />
              </fieldset>
              -->
            </div>

            <h3 style="margin-bottom: 0;">Agent Information</h3>
            <p><small>You may skip this section unless you're a selling or listing agent.</small></p>
            <div class="clearfix">
              <fieldset class="half">
                <label for="title">Professional Title</label>
                <input v-model="userData.title" id="title" type="text" />
              </fieldset>
              <fieldset class="half">
                <label for="dreNumber">DRE License Number</label>
                <input v-model="userData.dreNumber" id="dreNumber" type="text" />
              </fieldset>
            </div>
            <div v-if="tenant">
              <div class="clearfix">
                <fieldset class="half">
                  <label>Current Company</label>
                  <div>{{ tenant | lowercase | capitalize }}</div>
                  <div><a :href="companyWebsiteUrl(tenant)">{{ companyWebsiteUrl(tenant) }}</a></div>
                </fieldset>
                <fieldset class="half">
                  <label>Role</label>
                  <div>{{ role | lowercase | capitalize }}</div>
                </fieldset>
              </div>
              <div>
              </div>
            </div>

          </div>

          <div class="c2">
            <fieldset v-if="hasPhoto">
              <div><img :src="viewPhotoUrl" class="user-avatar" /></div>
              <div><button class="btn-neutral btn-small" @click.prevent="removePhoto">Remove Photo</button></div>
            </fieldset>
            <fieldset v-else>
              <croppa v-model="myCroppa"
                      :width="170"
                      :height="170"
                      :canvas-color="'#eee'"
                      :placeholder="'Choose a photo'"
                      :placeholder-font-size="16"
                      :placeholder-color="'#666'"
                      :accept="'image/*'"
                      :file-size-limit="10240000"
                      :quality="2"
                      :zoom-speed="10"
                      :disabled="false"
                      :disable-drag-and-drop="false"
                      :disable-click-to-choose="false"
                      :disable-drag-to-move="false"
                      :disable-scroll-to-zoom="false"
                      :disable-rotation="true"
                      :prevent-white-space="true"
                      :reverse-scroll-to-zoom="false"
                      :show-remove-button="true"
                      :remove-button-color="'grey'"
                      :remove-button-size="32"
                      :initial-size="'cover'"
                      @init="handleCroppaInit"
                      @file-choose="handleCroppaFileChoose"
                      @file-size-exceed="handleCroppaFileSizeExceed"
                      @file-type-mismatch="handleCroppaFileTypeMismatch"
                      @image-remove="handleImageRemove"
                      @move="handleCroppaMove"
                      @zoom="handleCroppaZoom">
              </croppa>
            </fieldset>

            <div style="margin-top: 5rem; color: #aaa; font-size: 0.7rem;">
              <p>User ID<br/>{{ userData.id }}</p>
              <p>Account Created<br/>{{ (userData.created||0) | prettyDateTimeShort }}</p>
              <p>Last Login<br/>{{ userData.lastLogin | prettyDateTime }}</p>
            </div>

          </div>
        </div>

        <div class="clearfix align-right">
          <fieldset>
            <button class="wider" @click.prevent="save" :disabled="this.$store.state.loadingSpinner">Update Profile</button>
          </fieldset>
        </div>

      </form>

    </div>
  </div>
</template>

<script>
  import ProfilePageMenu from './ProfilePageMenu.vue'
  import { isUserProfileIncomplete } from '../utils/PfxUtils.js'
  import { mapGetters, mapMutations } from 'vuex'
  const DEFAULT_PHOTO_URL = require('../assets/placeholder-user.png')

  export default {
    name: 'ProfilePage',
    components: {
      ProfilePageMenu
    },
    data() {
      return {
        myCroppa: {},
        userData: {
          id: '',
          firstName: '',
          lastName: '',
          alias: '',
          email: '',
          phone: '',
          officePhone: '',
          fax: '',
          title: '',
          dreNumber: '',
          photoUrl: '', // for reading photo during GET
          photoData: null  // for updating photo during POST
        },
        photoData: {
          filename: '',
          dataUri: ''
        },
        complete: true,
        signup: undefined
      }
    },
    computed: {
      ...mapGetters([
        'role',
        'tenant',
        'getTargetPage'
      ]),
      hasPhoto() {
        return this.viewPhotoUrl !== DEFAULT_PHOTO_URL
      },
      viewPhotoUrl() {
        return this.userData.photoUrl ? this.userData.photoUrl : DEFAULT_PHOTO_URL
      }
    },
    created() {
      this.loadUserData()
    },
    methods: {
      ...mapMutations([
        'closeDialog'
      ]),
      loadUserData() {
        if (!this.$store.state.user.cognitoSubject) {
          return
        }

        // use cache profile data from store
        if (this.$store.state.user.profile.id) {
          console.debug('using cached profile')
          this.userData = this.$store.state.user.profile
          this.checkIfIncomplete()
          return
        }

        // load from backend
        const that = this
        this.$store.commit('setLoadingSpinner', true)
        this.$PfxBackendApi.getUser(this.$store.state.user.cognitoSubject).then(res => {
          that.userData = res.data
          that.checkIfIncomplete()
        }).catch(err => {
          console.error('getUser error', err)
          this.$notify({ type: 'error', message: 'Cannot load user profile: ' + err })
        }).then(() => {
          that.$store.commit('setLoadingSpinner', false)
        })
      },

      checkIfIncomplete() {
        if (isUserProfileIncomplete(this.userData)) {
          this.$notify({ type: 'info', message: 'Your profile is not yet complete. Please update it.' })
          this.complete = false
        } else {
          this.complete = true
        }
        // This is run once on arrival to page
        if ( typeof this.signup === 'undefined') {
          this.signup = !this.complete
        }
        // Check if we need to take the user back to somewhere
        if ( this.signup && this.complete && this.getTargetPage ) {
          this.$router.push(this.getTargetPage)
        }
      },

      removePhoto() {
        this.userData.photoUrl = ''
        this.userData.photoData = null
        this.photoData.dataUri = ''
        this.photoData.filename = ''
      },

      handleCroppaInit() {},
      handleCroppaFileChoose() {},
      handleCroppaFileSizeExceed() {
        this.$store.commit('openDialog', 'Image file size was too big. Maximum file size is 10MB.')
      },
      handleCroppaFileTypeMismatch() {
        this.$store.commit('openDialog', 'File type was not an image.')
      },
      handleImageRemove() {},
      handleCroppaMove() {},
      handleCroppaZoom() {},

      save() {
        if (!this.$refs.profileForm.checkValidity()) {
          this.$refs.profileForm.reportValidity()
          return
        }

        this.$store.commit('setLoadingSpinner', true)

        const submit = this.userData
        delete submit.photo
        delete submit.photoUrl
        submit.id = this.$store.state.user.cognitoSubject
        if (this.myCroppa.hasImage && this.myCroppa.hasImage()) {
          submit.photoData = {
            dataUri: this.myCroppa.generateDataUrl('image/jpeg', 0.8),
            filename: this.$store.state.user.cognitoSubject + '-user.jpg'
          }
        }

        const that = this
        this.$PfxBackendApi.postUser(submit)
          .then(res => {
            console.log('postUser res', res)
            that.$store.commit('setLoadingSpinner', false)
            that.userData = res.data
            if (that.userData.photoUrl) {
              that.userData.photoUrl = that.userData.photoUrl + '?refresh=' + new Date().getTime()
            }
            that.checkIfIncomplete()
            this.$store.commit('setUserProfile', res.data)
            this.$notify({ type: 'info', message: 'Profile updated' })
          })
          .catch(err => {
            console.error('postUser err', err)
            that.$store.commit('setLoadingSpinner', false)
            this.$notify({ type: 'danger', message: 'Unexpected error during profile update' })
          })
      },

      companyWebsiteUrl(subdomain) {
        const pfxLandingPage = process.env.config.frontend.pfxLandingPage
        const tenantLandingPage = pfxLandingPage.replace(/\/\//, '//' + subdomain + '.')
        return tenantLandingPage
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  h2 { font-weight: 300; }
  label {
    font-weight: 600;
  }

  .user-avatar {
    width: 50%;
  }

  .clearfix {
    @include clearfix();
  }

  .c1 {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(2/3);
    }
  }
  .c2 {
    text-align: center !important;
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(1/3);
    }
  }

  .half {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(1/2, $cycle: 2);
    }
  }

  .incomplete-profile {
    font-size: 1.5em;
    font-weight: 300;
    padding: 2rem 1rem;
    margin: 1rem 0;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProfilePage.vue